import React, { useMemo } from "react";
import { Avatar, Box, Chip, Grid2, Stack, Typography } from "@mui/material";
import Complete from "./Complete";
import { generateLinkImage } from "../../../../utils/helpers";

interface IDetail {
  data: any;
}

function Detail({ data }: IDetail) {
  const slCanCheBien = useMemo(() => {
    return (data?.sl_order || 0) - (data?.sl_xuat || 0);
  }, [data?.sl_order, data?.sl_xuat]);

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        px: 2,
        py: 1,
        borderRadius: "10px",
      }}
    >
      <Grid2 container spacing={2}>
        <Grid2 order={{ xs: 1 }} size={{ xs: 12, md: 4 }}>
          <Stack direction="row" alignItems="flex-start" gap={1}>
            <Avatar
              src={
                data?.picture
                  ? generateLinkImage(data.picture)
                  : "/product.jpeg"
              }
              sx={{ width: "50px", height: "50px", borderRadius: "10px" }}
            />
            <Typography>
              {data?.ten_vt}{" "}
              <Chip
                component="span"
                variant="outlined"
                size="small"
                color="primary"
                label={data?.ten_dvt || data?.ma_dvt}
              />{" "}
            </Typography>
          </Stack>
        </Grid2>
        <Grid2 order={{ xs: 2 }} size={{ xs: 6, md: 3 }}>
          <Stack alignItems="center">
            <Typography>Cần chế biến</Typography>
            <Typography
              sx={{ fontWeight: 600, color: "error.main", fontSize: "18px" }}
            >
              {slCanCheBien}
            </Typography>
          </Stack>
        </Grid2>
        <Grid2 order={{ xs: 3 }} size={{ xs: 6, md: 3 }}>
          <Stack alignItems="center">
            <Typography>Tổng số lượng</Typography>
            <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
              {data?.sl_order}
            </Typography>
          </Stack>
        </Grid2>
        {data?.ghi_chu && (
          <Grid2 order={{ xs: 4, md: 5 }} size={{ xs: 12 }}>
            <Typography>Ghi chú: {data?.ghi_chu || ""}</Typography>
          </Grid2>
        )}
        <Grid2 order={{ xs: 5, md: 4 }} size={{ xs: 12, md: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Complete
              data={data}
              slDaCheBien={data?.sl_xuat || 0}
              slCanCheBien={slCanCheBien}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default Detail;
